import { render, staticRenderFns } from "./UpdateServices.vue?vue&type=template&id=5f133203"
import script from "./UpdateServices.vue?vue&type=script&lang=js"
export * from "./UpdateServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports